<template>
  <layout>
    <router-view/>
  </layout>
</template>

<script>
import layout from './components/partials/layout'
export default {
  name: 'App',
  components: { layout }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  img {
    &.is-rounded {
      border-radius: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue